// 导入axios
import axios from 'axios';

// 公共路由(网络请求地址)
// axios.defaults.baseURL = IPCONFIG;
// 请求响应超时时间
axios.defaults.timeout = 25000;
// axios.defaults.headers.common['Authorization'] = localStorage.getItem("tokentype") + " " + localStorage.getItem("mytoken")
axios.interceptors.request.use(
    // function(config) {
    //     // 在发送请求之前做些什么
    //     console.log(localStorage.getItem('mytoken'))
    //     if (localStorage.getItem("mytoken")) {
    //         // config.headers.Authorization = localStorage.getItem("mytoken");
    //         //  console.log(localStorage.getItem('mytoken'))
    //     }
    //     // console.log(config)
    //     return config;
    // },
    // function(error) {
    //     // 对请求错误做些什么
    //     return Promise.reject(error);
    // }
);

// 添加响应拦截器
axios.interceptors.response.use(
    function(response) {
        // 对响应数据做点什么
        // return response.data
        return response;
    },
    function(error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);
// 封装自己的get/post方法
export default {
    get(path = '', data = {}) {
        return new Promise(function(resolve, reject) {
            axios.get(path, {
                    params: data
                })
                .then(function(response) {
                    // 按需求来，这里我需要的是response.data，所以返回response.data，一般直接返回response
                    resolve(response.data);
                })
                .catch(function(error) {
                    reject(error);
                });
        });
    },
    post(path = '', data = {},headers={}) {
        return new Promise(function(resolve, reject) {
            axios.post(path, data,headers)
                .then(function(response) {
                    resolve(response.data);
                })
                .catch(function(error) {
                    reject(error);
                });
        });
    }
};


// WEBPACK FOOTER //
// ./src/api/newHttp.js